import * as React from 'react';
import DatePicker from 'react-mobile-datepicker';
import * as ReactDOM from 'react-dom';
import './index.scss'


interface initProps{
	visiblity?: any,
	close?(): void,
	open?(): void,
	onCancelFn?(): void,
}


class DatePickerBox extends React.Component <initProps, any> {
	constructor(props: any) {
		super(props);
		this.state = {
			time: new Date(),
			visiblity: false,
			onCancelFn: '',
		}
	}

	public close() {
		const body = (document as any).body;
		body.style.overflow = 'auto';

        this.setState({
            visiblity:false
        })
    }

    public open =(options?: any)=> {
		const body = (document as any).body;
		body.style.overflow = 'hidden';

        this.setState({
            visiblity: true,
            onCancelFn: options.onCancelFn ? options.onCancelFn : '',
        })
    }


	render() {
		return (
			<div>
				<DatePicker
					value={this.state.time}
					isOpen={this.state.visiblity}
					confirmText={'确认'}
					theme='ios'
					onCancel={() => this.close()}
					dateConfig={
						{
							'year': {
					        format: 'YYYY',
					        caption: 'Year',
					        step: 1,
					    },
					    'month': {
					        format: 'MM',
					        caption: 'Mon',
					        step: 1,
					    },
					    'date': {
					        format: 'DD',
					        caption: 'Day',
					        step: 1,
					    }

						}
					}
					onSelect={(time:any) => this.onSelect(time)}
					/>
			</div>
		)
	}

	private onSelect(time: any) {
		const data = new Date(time);
		const year = data.getFullYear();
		const month = data.getMonth() + 1;
		const date = data.getDate();
		const hours = data.getHours();
		const minutes = data.getMinutes();
		const seconds = data.getSeconds();
		const defaultDate = year + '-' + month + '-' + date;
		const defaultTime = hours + '.' + minutes + '.' + seconds;

		const result = {
			year: year,
			month: month,
			date: date,
			hours: hours,
			minutes: minutes,
			seconds: seconds,
			defaultDate: defaultDate,
			defaultTime: defaultTime,
		}

		if(this.state.onCancelFn) {
			this.state.onCancelFn(result)
		}

		this.close();


		return  defaultDate + defaultTime

	}
}

let div = document.createElement('div');
document.body.appendChild(div);
let DatePickers  = ReactDOM.render(<DatePickerBox /> ,div); 

export default (DatePickers as any); 